import { ProjectType } from '@/api/project';
import { SpiritTaskItem } from '@/api/spirit';
import CalendarIcon from '@/assets/icons/calendar.svg';
import FeedbackPeriod from '@/assets/icons/feedback_reriod.svg';
import ResltAnnounicement from '@/assets/icons/recruitment_result_announcement.svg';
import RecuimentIcon from '@/assets/icons/requiment_period.svg';
import { scheduleToString } from '@/utils/format';

import { TaskManeger } from './tasksManager';

type PreviewScheduleProps = {
  projectType: ProjectType;
  recruitmentStartedAt: string | null;
  recruitmentEndedAt: string | null;
  recruitmentResultPeriodStartedAt: string | null;
  recruitmentResultPeriodEndedAt: string | null;
  feedbackPeriodStartedAt?: string | null;
  feedbackPeriodEndedAt?: string | null;
  tasks?: SpiritTaskItem[];
};

export const PreviewSchedule = (props: PreviewScheduleProps) => {
  return (
    <div className=" mb-[26px] px-4 text-gray-700">
      <h4 className="mb-4 text-lg font-semibold leading-7 ">スケジュール</h4>
      <div className="mb-6 rounded-md bg-[#F3F4F6] px-4 py-6">
        {/* 募集期間 */}
        <div className="flex h-[76px] w-full gap-3">
          <div className="flex flex-col items-center text-sm">
            <div className="flex aspect-square w-10 items-center justify-center rounded-[20px] bg-white">
              <img className="aspect-square" src={RecuimentIcon} alt="" />
            </div>
            <div className="h-[50px] w-[2px] bg-gray-300" />
          </div>
          <div>
            <h5 className="font-semibold leading-7 ">募集期間</h5>
            {(props.recruitmentStartedAt || props.recruitmentEndedAt) && (
              <p className="text-xs">{scheduleToString(props.recruitmentStartedAt, props.recruitmentEndedAt)}</p>
            )}
          </div>
        </div>
        {/* 採用結果発表日 */}
        <div className="flex h-[76px] w-full gap-3">
          <div className="flex flex-col items-center text-sm">
            <div className="flex aspect-square w-10 items-center justify-center rounded-[20px] bg-white">
              <img src={ResltAnnounicement} alt="" />
            </div>
            <div className="h-[50px] w-[2px] bg-gray-300" />
          </div>
          <div>
            <h5 className="font-semibold leading-7 ">採用結果発表日</h5>
            {(props.recruitmentResultPeriodStartedAt || props.recruitmentResultPeriodEndedAt) && (
              <p className="text-xs">
                {scheduleToString(props.recruitmentResultPeriodStartedAt, props.recruitmentResultPeriodEndedAt)}
              </p>
            )}
          </div>
        </div>
        {/* 稼働 */}
        {props.tasks && props.tasks.length ? <TaskManeger tasks={props.tasks} /> : <></>}
        {/* フィードバック */}
        {props.projectType !== ProjectType.Spirit && (
          <div className="flex min-h-[40px] w-full gap-3">
            <div className="flex flex-col items-center text-sm">
              <div className="flex aspect-square w-10 items-center justify-center rounded-[20px] bg-white">
                <img src={CalendarIcon} alt="" />
              </div>
              {props.projectType !== ProjectType.Prst && <div className="h-[50px] w-[2px] bg-gray-300" />}
            </div>
            <div>
              <h5 className="font-semibold leading-7 ">稼働期間</h5>
              <p className="text-xs">今後のスケジュールにつきましては、担当者からご連絡いたします。</p>
            </div>
          </div>
        )}
        {props.feedbackPeriodStartedAt !== undefined && props.feedbackPeriodEndedAt !== undefined && (
          <div className="flex h-[40px] gap-3">
            <div className="flex flex-col items-center text-sm">
              <div className="flex aspect-square w-10 items-center justify-center rounded-[20px] bg-white">
                <img src={FeedbackPeriod} alt="" />
              </div>
            </div>
            <div>
              <h5 className="font-semibold leading-7 ">フィードバック期間</h5>
              <p className="text-xs">{scheduleToString(props.feedbackPeriodStartedAt, props.feedbackPeriodEndedAt)}</p>
            </div>
          </div>
        )}
      </div>
      <div className="mb-4 h-[1px] w-[273px] bg-gray-300" />
    </div>
  );
};
